export default __webpack_public_path__ + "imgs/Roku_logo.9b496246070c92a0e87c3d82b2659cad.svg";